// src/components/Footer.tsx
import React from 'react';
import { TextLink } from 'shared-portal-component';

const Footer: React.FC = () => (
  <footer className="w-full py-4 text-left color-white text-sm bg-transparent text-white flex justify-center">
    <nav className="space-x-4 flex justify-center flex-wrap gap-4 w-1/2">
      <TextLink text="Terms of Service" href="/terms" variant="tertiary"/>
      <TextLink text="Privacy Policy" href="/privacy" variant="tertiary"/>
      <TextLink text="Contact Us" href="/contact" variant="tertiary"/>
    </nav>
  </footer>
);

export default Footer;
